import { Layout } from 'antd'
import { Content } from 'antd/lib/layout/layout'
import React from 'react'

import Header from 'src/pages/HomePage/Header'
import FooterSection from 'src/pages/HomePage/Footer'
//import SocialNetwork from 'src/components/SocialNetwork'

const MainLayout: React.FC = ({children}) => {
  return (
    <Layout>
      <Header/>
      <Content style={{overflow: 'hidden'}}>
        {children}
      </Content>
      {/* <SocialNetwork id="social"/> */}
      <FooterSection/>
    </Layout>
  )
}

export default MainLayout
